import { DatabaseOperationEnum } from '../../../enums/database-operation.enum';
import { AppSubjectEnum } from '../../authz/enums/app-subject.enum';
import { CaslSubject } from '../../authz/decorators/casl-subject.decorator';

/**
 * Change log DTO for records
 */
@CaslSubject(AppSubjectEnum.CHANGE_LOG)
export class ChangeLogRecordDto {
	id!: number;
	tableName!: string;
	tableRowId!: number;
	operation!: DatabaseOperationEnum;
	timestamp!: Date;
}
